import React from 'react'

const Button = ({children, className, style, onClick, thin, ...props}) => {
  const handleClick = (e) => {
    e.preventDefault();
    if(typeof onClick === 'function'){
      onClick(e);
    }
  }

  return (
    <button
      className={`bg-primary rounded text-center ${thin ? 'p-2' : 'p-4'} w-full text-white font-bold text-sm ${className}`}
      style={style}
      onClick={handleClick}
      {...props}
    >
      {children}
    </button>
  )
}

export { Button }
